import React from 'react'
import { cn, dateChatFormat } from '@utils/safeTs'
import { LogStatoOrdineType, LogStatoPosizionePersonalizzazioneOrdineType, PosizionePersonalizzazioneCarrelloLogType } from '@utils/types'
import StatoOrdine from '@components/atoms/StatoOrdine/StatoOrdine'
import styles from './ChatLog.module.sass'
import useTrans from '@hooks/useTrans'

export interface ChatLogProps {
  item: LogStatoPosizionePersonalizzazioneOrdineType & LogStatoOrdineType
  level: 'posizione' | 'ordine'
  mostraOriginali?: boolean
  className?: string
}

export default function ChatLog({ item, level, mostraOriginali = false, className }: ChatLogProps) {
  
  const t = useTrans()
  const note = level === 'posizione' && !mostraOriginali ? item.noteTradotta || item.note : item.note

  return (
    <article className={cn(styles.root, className)} role="listitem">
      <div className={styles.head}>
        <span className={styles.data}>{dateChatFormat(item.created, t)}</span>
        <h3 className={styles.title}>
          <span className={styles.personalizzazione}>
            {level === 'posizione' && (
              t("Personalizzazione: {0}", [item.posizionePersonalizzazioneOrdine?.personalizzazione?.nomeLavorazione])
            )}
            {level === 'ordine' && (
              t("Ordine")
            )}
          </span>
          <span className={styles.posizione}>
            {level === 'posizione' && (
              item.posizionePersonalizzazioneOrdine?.posizione?.nome
            )}
            {level === 'ordine' && (
              item.numeroDocumento
            )}
          </span>
        </h3>
      </div>
      <div className={styles.body}>
        <p className={styles.description}>{level === 'ordine' ? t(note) : note}</p>
        <StatoOrdine
          level={level}
          stato={item.stato}
          userType='admin'
          className={styles.status}
        />
      </div>
    </article>
  )
}
